import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const rootSx: SxProps<Theme> = {
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  gap: '100px',
  background: Color.solidGray,
};

export const contentSx: SxProps<Theme> = {
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '33px',
  width: '100%',
  position: 'relative',
};

export const projectBoxSx: SxProps<Theme> = {
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '15px',
  position: 'absolute',
  transform: 'translate(0,-100%)',
  top: '-100px',
};

const archivoTextSx = {
  fontFamily: 'Archivo',
  fontWeight: 400,
  letterSpacing: '0em',
  textAlign: 'center',
} as const;

export const projectLabelSx: SxProps<Theme> = { ...archivoTextSx, fontSize: '1rem', lineHeight: '17px' };

export const projectNameSx: SxProps<Theme> = { ...archivoTextSx, fontSize: '1.5rem', lineHeight: '26px' };

export const headlineSx: SxProps<Theme> = { ...archivoTextSx, fontSize: '1.5rem', fontWeight: 700, lineHeight: '26px' };

export const descriptionSx: SxProps<Theme> = {
  ...archivoTextSx,
  fontSize: '1rem',
  lineHeight: '22px',
  maxWidth: 'min(90%, 480px)',
};

export const progressBoxSx: SxProps<Theme> = {
  width: 'min(90%, 340px)',
  textAlign: 'center',
};

export const actionsSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '16px',
};
